import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import PropTypes from "prop-types";
import { ReactCalendar } from "@vds-core/calendars";
import styled from "styled-components";
import { calculateRem } from "@uie/javascript-style-helpers";
import { breakpoints, colors, calculateSpacing } from "@vds/theme";
import { BodyConfig, TypographyConfig } from "@vds/typography";
import Icon from "@vds/icons";
/*
fontWeightStrong represents the font weight found in 
typography used when the component is bolded. Font weight is
not exported by typography configs due to the fact that 
typography components may have multiple font weight options
*/

var fontWeightStrong = 750;
var propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Callback used to get the selected date from Calendar.
   */
  onChange: PropTypes.func,

  /**
   * If provided, this is the date that will show as selected by the Calendar. If no value is provided, the current date will be used.
   */
  selectedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),

  /**
   * A custom width can be passed to calendar for scalability purposes.
   */
  width: PropTypes.number,

  /**
   * @deprecated
   * Callback used to get the selected date from Calendar.
   */
  handleDatePick: PropTypes.func,

  /**
   * @deprecated
   * The beginning of a period that shall be displayed by the Calendar. If no value is provided, the current date (<code>new Date()</code>) will be used.
   */
  activeStartDate: PropTypes.instanceOf(Date),

  /**
   * @ignore
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * If provided, the calendar will allow a selection to be made from this date forward. Defaults to today.
   */
  minDate: PropTypes.instanceOf(Date),

  /**
   * If provided, the calendar will allow a selection to be made up to this date.
   */
  maxDate: PropTypes.instanceOf(Date),

  /**
   * @deprecated minDate
   */
  pastDatesDisabled: PropTypes.bool,

  /**
   * If provided, the calendar will render the inverted state.
   */
  inverted: PropTypes.bool,

  /**
   * Enable specific days. Pass an array of string elements in date format e.g. ['07/21/2020', '07/24/2020', '07/28/2020'].  All other dates will be inactive.
   */
  activeDates: PropTypes.array,

  /**
   * Disable specific days. Pass an array of string elements in date format e.g. ['07/21/2020', '07/24/2020', '07/28/2020'].  All other dates will be active.
   */
  inactiveDates: PropTypes.array
};
var defaultProps = {
  className: null,
  selectedDate: undefined,
  onChange: function onChange() {},
  width: undefined,
  bodyConfig: BodyConfig,
  typescale: undefined,
  colorConfig: colors,
  minDate: new Date(),
  pastDatesDisabled: false //Deprecated
  //handleDatePick: () => {},
  //activeStartDate: new Date(),

};
var CalendarWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CalendarWrapper",
  componentId: "sc-4mmd93-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: ", ";\n  position: ", ";\n  top: ", ";\n\n  @media screen and (max-width: ", ") {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n"])), function (_ref) {
  var isOpen = _ref.isOpen,
      datePicker = _ref.datePicker;
  return !datePicker ? "block" : isOpen ? null : "none";
}, function (_ref2) {
  var datePicker = _ref2.datePicker;
  return !datePicker ? "relative" : "absolute";
}, function (_ref3) {
  var datePicker = _ref3.datePicker,
      calendarTop = _ref3.calendarTop;
  return !datePicker ? 0 : calculateRem(calendarTop);
}, breakpoints.xs);
var IconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-4mmd93-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  &:focus {\n    outline: none;\n  }\n  height: ", ";\n  width: ", ";\n"])), calculateRem(44), calculateRem(44));
var StyledCalendar = /*#__PURE__*/styled(ReactCalendar).withConfig({
  displayName: "StyledCalendar",
  componentId: "sc-4mmd93-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  &.react-calendar {\n    z-index: 5;\n    background-color: ", ";\n    box-sizing: content-box;\n    border: ", " solid\n      ", ";\n    position: relative;\n    padding: ", ";\n    width: ", ";\n    min-width: ", ";\n    font-family: ", ";\n    button {\n      &:active,\n      &:hover,\n      &:visited {\n        outline: none;\n      }\n    }\n  }\n\n  @media screen and (max-width: ", ") {\n    &.react-calendar {\n      padding: 0;\n    }\n  }\n\n  .react-calendar__month-view {\n    padding: 0;\n  }\n\n  .react-calendar__month-view__weekdays {\n    padding-bottom: ", ";\n    justify-content: ", ";\n    text-align: center;\n    justify-content: center;\n\n    .react-calendar__month-view__weekdays__weekday {\n      margin: ", ";\n      color: ", ";\n      box-sizing: content-box;\n      font-size: ", ";\n      font-family: ", ";\n      font-weight: ", ";\n      line-height: ", ";\n      padding: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: ", ";\n      height: ", ";\n    }\n\n    abbr[title] {\n      font-family: ", ";\n      text-decoration: none;\n    }\n  }\n\n  .react-calendar__navigation__label {\n    background-color: ", ";\n    border: none;\n    color: ", ";\n\n    font-size: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    padding: 0;\n    margin: ", ";\n    cursor: pointer;\n    outline: none;\n    display: flex;\n    flex: 1;\n    justify-content: center;\n  }\n\n  .react-calendar__viewContainer {\n    margin: ", ";\n  }\n\n  .react-calendar__navigation {\n    background-color: ", ";\n    margin: ", ";\n    padding: ", ";\n    flex: 1;\n    display: flex;\n  }\n\n  button::-moz-focus-inner {\n    border: 0;\n  }\n\n  abbr {\n    position: relative;\n    z-index: 1;\n  }\n\n  .react-calendar__navigation__next-button {\n    right: ", ";\n\n    &:-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  .react-calendar__navigation__prev-button {\n    left: ", ";\n\n    &:-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  .react-calendar__navigation__next-button[disabled] {\n    display: none;\n  }\n\n  .react-calendar__navigation__prev-button[disabled] {\n    display: none;\n  }\n\n  .react-calendar__navigation__arrow {\n    &:focus {\n      outline: none;\n      &:not(:hover):not(:visited):not(:active) > ", " {\n        &::after {\n          background: transparent;\n          border: ", " dashed\n            ", ";\n\n          box-sizing: border-box;\n          content: \"\";\n          height: ", ";\n          left: 50%;\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: ", ";\n        }\n      }\n    }\n\n    &:hover svg g path {\n      stroke-width: 2px;\n    }\n\n    &:active svg g path {\n      stroke: ", ";\n    }\n\n    &:-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  .react-calendar__navigation__next-button,\n  .react-calendar__navigation__prev-button {\n    align-items: center;\n    border: 0;\n    background-color: ", ";\n    cursor: pointer;\n    display: flex;\n    height: ", ";\n    justify-content: center;\n    padding: 0;\n    position: absolute;\n    top: ", ";\n    width: ", ";\n    z-index: 1;\n\n    &:focus {\n      outline-offset: -12px;\n    }\n  }\n\n  .react-calendar__navigation__next2-button,\n  .react-calendar__navigation__prev2-button {\n    display: none;\n  }\n\n  .react-calendar__year-view__months {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-calendar__decade-view__years {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-calendar__decade-view__years {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-calendar__century-view__decades {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  /* Day tiles */\n  .react-calendar__month-view__days {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-calendar__tile {\n    background-color: ", ";\n    border: none;\n    box-sizing: content-box;\n    color: ", ";\n    flex-basis: auto !important;\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    overflow: visible !important;\n    padding: 0;\n    position: relative;\n\n    &.react-calendar__month-view__days__day {\n      height: ", ";\n      width: ", ";\n    }\n\n    &:hover:not(.react-calendar__month-view__days__day--neighboringMonth),\n    &.react-calendar__tile--active,\n    &.react-calendar__tile--hover,\n    &.react-calendar__tile--rangeStart,\n    &.react-calendar__tile--rangeEnd,\n    &.react-calendar__tile--rangeBothEnds {\n      color: ", ";\n      cursor: pointer;\n\n      &::before {\n        background-color: ", ";\n        content: \"\";\n        height: ", ";\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: ", ";\n      }\n    }\n    &:hover {\n      background-color: ", ";\n    }\n    &:focus {\n      background-color: ", ";\n\n      outline: none;\n      + svg {\n        outline: none;\n      }\n      &:not(:hover):not(:visited):not(:active) {\n        &::after {\n          background: transparent;\n          border: ", ";\n          box-sizing: border-box;\n          content: \"\";\n          height: ", ";\n          left: 50%;\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: ", ";\n        }\n      }\n    }\n\n    &:disabled {\n      color: ", ";\n\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n        cursor: default;\n      }\n\n      &:hover:not(.react-calendar__month-view__days__day--neighboringMonth),\n      &.react-calendar__tile--active,\n      &.react-calendar__tile--hover,\n      &.react-calendar__tile--rangeStart,\n      &.react-calendar__tile--rangeEnd,\n      &.react-calendar__tile--rangeBothEnds {\n        &::before {\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  .react-calendar__month-view__days__day--neighboringMonth {\n    color: ", ";\n    font-weight: normal;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  @media screen and (max-width: 359px) {\n    &.react-calendar {\n      padding: 0;\n      width: ", ";\n    }\n  }\n  .react-calendar__navigation button[disabled] {\n    background-color: ", ";\n  }\n  .react-calendar__navigation button:enabled {\n    &:hover {\n      background-color: ", ";\n    }\n    &:focus {\n      background-color: ", ";\n    }\n  }\n"])), function (_ref4) {
  var colorConfig = _ref4.colorConfig,
      inverted = _ref4.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, calculateRem(1), function (_ref5) {
  var colorConfig = _ref5.colorConfig,
      inverted = _ref5.inverted;
  return inverted ? colorConfig.white : colorConfig.black;
}, calculateSpacing("1X"), calculateRem(318), calculateRem(318), function (_ref6) {
  var bodySmall = _ref6.bodySmall;
  return bodySmall.fontFamily;
}, breakpoints.xs, null, null, calculateRem(6, 6), function (_ref7) {
  var colorConfig = _ref7.colorConfig;
  return colorConfig.coolGray6;
}, function (_ref8) {
  var bodySmall = _ref8.bodySmall;
  return calculateRem(bodySmall.fontSize);
}, function (_ref9) {
  var bodySmall = _ref9.bodySmall;
  return bodySmall.fontFamily;
}, fontWeightStrong, calculateRem(28), calculateRem(32), calculateRem(32), function (_ref10) {
  var bodySmall = _ref10.bodySmall;
  return bodySmall.fontFamily;
}, function (_ref11) {
  var colorConfig = _ref11.colorConfig,
      inverted = _ref11.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, function (_ref12) {
  var colorConfig = _ref12.colorConfig,
      inverted = _ref12.inverted;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref13) {
  var bodySmall = _ref13.bodySmall;
  return calculateRem(bodySmall.fontSize);
}, function (_ref14) {
  var bodySmall = _ref14.bodySmall;
  return bodySmall.fontFamily;
}, fontWeightStrong, function (_ref15) {
  var bodySmall = _ref15.bodySmall;
  return calculateRem(bodySmall.lineHeight);
}, "".concat(calculateRem(0), " ").concat(calculateSpacing("5X")), calculateRem(0, 5, 5, 5), function (_ref16) {
  var colorConfig = _ref16.colorConfig,
      inverted = _ref16.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, calculateRem(5, 5, 0, 5), calculateRem(14), calculateRem(8), calculateRem(8), IconWrapper, calculateRem(1), function (_ref17) {
  var colorConfig = _ref17.colorConfig,
      inverted = _ref17.inverted;
  return inverted ? colorConfig.white : colorConfig.black;
}, calculateRem(22), calculateRem(22), colors.coolGray6, function (_ref18) {
  var colorConfig = _ref18.colorConfig,
      inverted = _ref18.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, calculateRem(44), calculateRem(8), calculateRem(44), function (_ref19) {
  var colorConfig = _ref19.colorConfig,
      inverted = _ref19.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, function (_ref20) {
  var disabled = _ref20.disabled,
      colorConfig = _ref20.colorConfig,
      inverted = _ref20.inverted;
  return disabled && !inverted ? colorConfig.coolGray3 : disabled && inverted ? colorConfig.coolGray10 : inverted ? colorConfig.white : colorConfig.black;
}, function (_ref21) {
  var bodySmall = _ref21.bodySmall;
  return bodySmall.fontFamily;
}, function (_ref22) {
  var bodySmall = _ref22.bodySmall;
  return calculateRem(bodySmall.fontSize);
}, fontWeightStrong, calculateRem(28), calculateRem(44), calculateRem(44), function (_ref23) {
  var colorConfig = _ref23.colorConfig,
      inverted = _ref23.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, function (_ref24) {
  var colorConfig = _ref24.colorConfig,
      inverted = _ref24.inverted;
  return inverted ? colorConfig.white : colorConfig.black;
}, calculateRem(32), calculateRem(32), function (_ref25) {
  var colorConfig = _ref25.colorConfig,
      inverted = _ref25.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, function (_ref26) {
  var colorConfig = _ref26.colorConfig,
      inverted = _ref26.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, function (_ref27) {
  var colorConfig = _ref27.colorConfig,
      inverted = _ref27.inverted;
  return inverted ? "".concat(calculateRem(1), " dashed ").concat(colorConfig.white) : "".concat(calculateRem(1), " dashed ").concat(colorConfig.black);
}, calculateRem(36), calculateRem(36), function (_ref28) {
  var colorConfig = _ref28.colorConfig,
      inverted = _ref28.inverted;
  return inverted ? colorConfig.coolGray10 : colorConfig.coolGray3;
}, function (_ref29) {
  var colorConfig = _ref29.colorConfig,
      inverted = _ref29.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, function (_ref30) {
  var colorConfig = _ref30.colorConfig,
      inverted = _ref30.inverted;
  return inverted ? colorConfig.coolGray10 : colorConfig.coolGray3;
}, function (_ref31) {
  var colorConfig = _ref31.colorConfig;
  return colorConfig.grayLight;
}, function (_ref32) {
  var customWidth = _ref32.customWidth;
  return customWidth ? calculateRem(customWidth) : calculateRem(318);
}, function (_ref33) {
  var colorConfig = _ref33.colorConfig,
      inverted = _ref33.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, function (_ref34) {
  var colorConfig = _ref34.colorConfig,
      inverted = _ref34.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
}, function (_ref35) {
  var colorConfig = _ref35.colorConfig,
      inverted = _ref35.inverted;
  return inverted ? colorConfig.black : colorConfig.white;
});

var Calendar = /*#__PURE__*/function (_React$Component) {
  _inherits(Calendar, _React$Component);

  var _super = _createSuper(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setAttributes", function () {
      _this.monthLabel = document.getElementsByClassName("react-calendar__navigation__label");
      _this.allButtons = document.getElementsByClassName("react-calendar__tile");
      _this.selectedButton = document.getElementsByClassName("react-calendar__tile--active"); // Converts HTMLCollection to Array, and sets attribute on each

      [].slice.call(_this.allButtons).forEach(function (day) {
        var abbr = day.querySelectorAll("abbr")[0];
        var ariaLabelDate = abbr.getAttribute("aria-label");

        if (day === _this.selectedButton[0]) {
          abbr.setAttribute("aria-live", "assertive");

          if (!ariaLabelDate.includes("selected")) {
            abbr.setAttribute("aria-label", "".concat(ariaLabelDate, " selected"));
          }
        } else {
          ariaLabelDate = ariaLabelDate.split(" selected")[0];
          abbr.setAttribute("aria-live", undefined);
          abbr.setAttribute("aria-label", ariaLabelDate);
        }
      });
      _this.monthLabel && _this.monthLabel[0] && _this.monthLabel[0].setAttribute("role", "presentation");
    });

    _defineProperty(_assertThisInitialized(_this), "_findNextDay", function (currentDate, inactiveDates) {
      var parse = Date.parse;
      var isThere = false;
      inactiveDates && inactiveDates.map(function (date) {
        var parsedDate = typeof date === "string" ? new Date(parse(date)) : date;

        if (parse(parsedDate) === parse(currentDate)) {
          isThere = true;
        }
      });

      if (isThere) {
        var tomorrow = new Date(currentDate);
        tomorrow.setDate(currentDate.getDate() + 1);
        return _this._findNextDay(tomorrow, inactiveDates);
      } else {
        return currentDate;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_findEarliestDay", function (currentDate, activeDates) {
      var parse = Date.parse;
      var currentDateExists = false;
      var minDate = new Date(8640000000000000); //largest date possible

      activeDates && activeDates.map(function (date) {
        var parsedDate = typeof date === "string" ? new Date(parse(date)) : date;

        if (parse(parsedDate) === parse(currentDate)) {
          minDate = parsedDate;
          currentDateExists = true;
        } else if (parse(parsedDate) < parse(minDate) && !currentDateExists) {
          minDate = parsedDate;
        }
      });
      return minDate;
    });

    _defineProperty(_assertThisInitialized(_this), "_getDate", function () {
      var _this$props = _this.props,
          error = _this$props.error,
          selectedDate = _this$props.selectedDate,
          activeStartDate = _this$props.activeStartDate,
          inactiveDates = _this$props.inactiveDates,
          activeDates = _this$props.activeDates;
      var parse = Date.parse;
      if (error) return null;
      if (selectedDate === null) return null;
      var currentDate = activeStartDate || selectedDate || new Date();
      currentDate = typeof currentDate === "string" ? new Date(parse(currentDate)) : currentDate;

      if (inactiveDates) {
        currentDate.setHours(0, 0, 0, 0);
        return _this._findNextDay(currentDate, inactiveDates);
      } else if (activeDates) {
        currentDate.setHours(0, 0, 0, 0);
        return _this._findEarliestDay(currentDate, activeDates);
      } else {
        return currentDate;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (selectedDate) {
      _this.setState({
        selectedDate: selectedDate
      });

      if (typeof _this.props.handleDatePick !== "undefined") _this.props.handleDatePick(selectedDate);
      if (typeof _this.props.onChange !== "undefined") _this.props.onChange(selectedDate);
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickDay", function (value, event) {
      event.screenX !== 0 && event.screenY !== 0 && event.currentTarget.blur(); // remove focus state on click
    });

    _defineProperty(_assertThisInitialized(_this), "_toggleDates", function () {
      var dates, active;
      var _this$props2 = _this.props,
          inactiveDates = _this$props2.inactiveDates,
          activeDates = _this$props2.activeDates; // add inactiveDates or activeDates to dates
      // when disable set active to true otherwise false.

      if (inactiveDates && inactiveDates.length) {
        dates = inactiveDates;
        active = true;
      } else if (activeDates && activeDates.length) {
        dates = activeDates;
        active = false;
      } else {
        return null;
      }

      return function (_ref36) {
        var date = _ref36.date;
        var isInactive = dates.filter(function (inactiveDate) {
          var toggleDate = new Date(inactiveDate);
          toggleDate.setHours(0, 0, 0, 0);
          return date.getTime() === toggleDate.getTime();
        });
        return !!isInactive.length ? active : !active;
      };
    });

    _this.state = {
      selectedDate: _this._getDate()
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setAttributes();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, nextProps) {
      if (prevProps && prevProps.selectedDate !== this.props.selectedDate) {
        this.setState({
          selectedDate: this.props.selectedDate
        });
      }

      this._setAttributes();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          bodyConfig = _this$props3.bodyConfig,
          typescale = _this$props3.typescale,
          colorConfig = _this$props3.colorConfig,
          disabled = _this$props3.disabled,
          minDate = _this$props3.minDate,
          calendarTop = _this$props3.calendarTop,
          maxDate = _this$props3.maxDate,
          inverted = _this$props3.inverted;
      var selectedDate = this.state.selectedDate;
      var calculatedTypescale = typescale ? typescale : TypographyConfig.getTypescale();
      var bodySmall = bodyConfig.getStyles(calculatedTypescale, "desktop", "small");
      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };
      return /*#__PURE__*/React.createElement(CalendarWrapper, {
        isOpen: this.props.isOpen,
        alwaysOpen: this.props.alwaysOpen,
        datePicker: this.props.datePicker,
        calendarTop: calendarTop
      }, /*#__PURE__*/React.createElement(StyledCalendar, _extends({}, this.props, {
        minDetail: "month",
        maxDetail: "month",
        showNeighboringMonth: false,
        bodyConfig: bodyConfig,
        disabled: disabled,
        bodySmall: bodySmall,
        typescale: typescale,
        customWidth: this.props.width,
        calendarType: "US",
        formatLongDate: function formatLongDate(locale, date) {
          return date.toLocaleDateString("en", options);
        },
        formatShortWeekday: function formatShortWeekday(locale, date) {
          return ["S", "M", "T", "W", "T", "F", "S"][date.getDay()];
        },
        tabIndex: 0,
        nextAriaLabel: "view next month",
        nextLabel: /*#__PURE__*/React.createElement(IconWrapper, {
          tabIndex: -1
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "caret-right",
          tabIndex: -1,
          size: "small",
          inverted: inverted
        })),
        onChange: this._onChange,
        prevAriaLabel: "view previous month",
        prevLabel: /*#__PURE__*/React.createElement(IconWrapper, {
          tabIndex: -1
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "caret-left",
          tabIndex: -1,
          size: "small",
          inverted: inverted
        })),
        value: selectedDate,
        colorConfig: colorConfig,
        minDate: minDate,
        maxDate: maxDate,
        tileDisabled: this._toggleDates(),
        onClickDay: this._onClickDay,
        inverted: inverted
      })));
    }
  }]);

  return Calendar;
}(React.Component);

Calendar.propTypes = propTypes;
Calendar.defaultProps = defaultProps;
export default Calendar;